import AnalyticsServerActionCreator from '../actions/AnalyticsActionServerCreator';
import config from '../config';
import envConfig from '../../static/config';
import ApiUtils from './ApiUtils';
import BrowserUtils from '../utils/BrowserUtils';
import UrlUtils from '../utils/UrlUtils';

const _eventsEndpoint = '/ibapi/v2/banks/{bank-id}/user/events';
const _beneficiaryEventsEndpoint =
  '/ibapi/v2/banks/{bank-id}/user/events/beneficiary';

const AnalyticsApiUtils = {
  getCommonAttributes(store) {
    return {
      userAgent: BrowserUtils.getUserAgent(),
      channelID: config.analytics.channelID,
      selectedProduct: this.getStoreValue(store, 'productCode'),
      url: UrlUtils.getFullUrl(),
      firstName: this.getStoreValue(store, 'firstName'),
      middleName: this.getStoreValue(store, 'middleName'),
      lastName: this.getStoreValue(store, 'lastName'),
    };
  },

  getCommonMetrics() {
    const _screenSize = BrowserUtils.getScreenSize();
    return {
      screenWidth: _screenSize ? _screenSize.x : undefined,
      screenHeight: _screenSize ? _screenSize.y : undefined,
    };
  },

  getViewContext() {
    return UrlUtils.getPathName();
  },

  getStoreValue(store, key) {
    if (store.getValue(key)) {
      return store.getValue(key);
    } else {
      return undefined;
    }
  },

  /**
   * Sends the event messages queue to the Analytics API. This method also
   * converts the array into a JSON to conform to the API standard.
   *
   * @param  {array} messages
   *
   */
  send(messages, isBeneficiaryEvent = false) {
    const requestData = messages;

    const url =
      envConfig.apiBaseUrlPAAS +
      (isBeneficiaryEvent ? _beneficiaryEventsEndpoint : _eventsEndpoint);

    if (!envConfig.disableAnalytics) {
      ApiUtils.makeAjaxCall(
        {
          apiVersion: config.apiVersions.eventServices,
          method: 'POST',
          url,
          bankID: config.analytics.defaultBankID,
          requestData,
          addAuthToken: true,
          doNotTrackCallProgress: true,
        },
        () => {
          AnalyticsServerActionCreator.handleDispatchSuccess();
        },
        () => {
          AnalyticsServerActionCreator.handleDispatchError();
        }
      );
    }
  },
};

export default AnalyticsApiUtils;
